import { PatientAttachmentAttachmentSource } from "../enums/patient-attachment-attachment-source.enum";

export const PatientAttachmentAttachmentSourceOptions = [
  { value: PatientAttachmentAttachmentSource.nuvemArs, display: 'Nuvem ARS' },
]
